import React from 'react';
import { StyledCardWrapper, StyledGridContainer, StyledSection, StyledTextPairing } from './GuestExperienceSection.styles';
import { AccountCard, CheckOutExperienceCard, LiveSupportCard } from './components';
import { registryPageData } from '@data-ts/pages/registry';

const { guestExperienceSection } = registryPageData;

export const GuestExperienceSection = () => {
  return (
    <StyledSection as="section" id="GuestExperienceSection">
      <StyledTextPairing
        alignment="center"
        title={guestExperienceSection.title}
        titleTagName="h2"
        titleColor="mono1"
        titleVariant="hed56"
        body={guestExperienceSection.body}
        bodyColor="mono1"
        bodyVariant="dek20"
      />
      <StyledGridContainer>
        <CheckOutExperienceCard />
        <StyledCardWrapper>
          <LiveSupportCard />
          <AccountCard />
        </StyledCardWrapper>
      </StyledGridContainer>
    </StyledSection>
  );
};
